import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/node_modules/@heroui/link/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
